import React from "react";
import { FolderOpenOutlined, WalletOutlined } from "@ant-design/icons";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import PermissionTabsLayout, {
  PermissionTabsRedirect,
} from "../components/PermissionTabsLayout.jsx";
import useIsMobile from "../hooks/useIsMobile";

const ADMIN_EXPENSE_TABS = [
  {
    key: "categories",
    label: "Categories",
    icon: <FolderOpenOutlined />,
    path: "/gestion-charges-admin/categories",
    permission: "Gestion Commerciale.Depenses.Categories.view",
  },
  {
    key: "saisie",
    label: "Saisie",
    icon: <WalletOutlined />,
    path: "/gestion-charges-admin/saisie",
    permission: "Gestion Commerciale.Depenses.SaisieDepenses.view",
  },
];

export const AdminExpensesTabsRedirect = () => (
  <PermissionTabsRedirect tabs={ADMIN_EXPENSE_TABS} />
);

const MOBILE_SHELL_ROUTES = /^\/gestion-charges-admin\/(categories|saisie)/;

const AdminExpensesTabsLayout = () => {
  const { pathname } = useLocation();
  const parentOutletContext = useOutletContext();
  const isMobile = useIsMobile();

  if (isMobile && MOBILE_SHELL_ROUTES.test(pathname)) {
    return <Outlet context={parentOutletContext} />;
  }

  return <PermissionTabsLayout tabs={ADMIN_EXPENSE_TABS} />;
};

export default AdminExpensesTabsLayout;
